import { axios } from 'lib';
import { useQuery } from 'react-query';

const defaultQueryParams = {
  queryKey: ['company'],
  queryOptions: {},
};

const getDirectCompanyByTcID = async (directID, tcID) => {
  const { data } = await axios.get(`/api/directs/${directID}/companies/${tcID}`);

  return data;
};

export const useCompany = (directID, tcID, queryParams = {}) => {
  const { queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  return useQuery([...queryKey, tcID], () => getDirectCompanyByTcID(directID, tcID), {
    initialData: { company_name: 'Company', FA: {} },
    ...queryOptions,
  });
};
